import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";

const radarDataFull = [
  { axis: "Brand", value: 90 },
  { axis: "GTM", value: 90 },
  { axis: "Tokenomics", value: 90 },
  { axis: "Community", value: 90 },
  { axis: "AI", value: 90 },
  { axis: "Workflow", value: 90 },
];

export default function Web3RadarChart() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const prefersReduced = useReducedMotion();
  const [data, setData] = useState(radarDataFull.map((d) => ({ ...d, value: 0 })));
  const [labelsVisible, setLabelsVisible] = useState(false);

  useEffect(() => {
    if (!inView) return;
    if (prefersReduced) {
      setData(radarDataFull);
      setLabelsVisible(true);
      return;
    }
    const timers: number[] = [];
    radarDataFull.forEach((point, i) => {
      timers.push(
        window.setTimeout(() => {
          setData((prev) => prev.map((d, j) => (j === i ? { ...d, value: point.value } : d)));
        }, i * 60),
      );
    });
    timers.push(window.setTimeout(() => setLabelsVisible(true), 800));
    return () => timers.forEach((t) => clearTimeout(t));
  }, [inView, prefersReduced]);

  return (
    <div ref={ref} className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} cx="50%" cy="50%" margin={{ top: 40, right: 80, bottom: 40, left: 80 }}>
          <PolarGrid stroke="hsl(var(--border))" strokeOpacity={0.4} />
          <PolarAngleAxis
            dataKey="axis"
            tick={{
              fill: "hsl(var(--muted-foreground))",
              fontSize: 11,
              fontFamily: "var(--font-mono, monospace)",
              opacity: labelsVisible ? 1 : 0,
              style: { transition: "opacity 0.6s ease" },
            }}
          />
          <Radar
            dataKey="value"
            stroke="hsl(var(--primary))"
            fill="hsl(var(--primary))"
            fillOpacity={0.15}
            strokeWidth={2}
            className="radar-pulse"
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
